"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _StackComponent.default;
  }
});

var _StackComponent = _interopRequireDefault(require("./Stack-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }